import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import spinnerSrc from '@cover/neustarten/spinner.png';
import cursorSrc from '@cover/neustarten/cursor.svg';

const AnimatedLayer = styled.img`
	position: absolute;
`

const CursorTop = styled(AnimatedLayer)`
	height: 21%;
	top: 30%;
	right: 28%;
	z-index: 999;
`
const SpinnerTop = styled(AnimatedLayer)`
	height: 28.5%;
	top: 4%;
	right: 30%;
	transform-origin: center center;
`


const CursorLeft = styled(AnimatedLayer)`
	height: 14%;
	bottom: 22%;
	left: 24%;
`
const SpinnerLeft = styled(AnimatedLayer)`
	height: 13.5%;
	bottom: 32.5%;
	left: 12%;
`


const CursorRight = styled(AnimatedLayer)`
	height: 11%;
	bottom: 8%;
	right: 5%;
	z-index: 999;
`
const SpinnerRight = styled(AnimatedLayer)`
	height: 25%;
	bottom: 11.5%;
	right: 8%;
`


const Neustarten = ({ play }) => {
	const cursorTop = useRef(false);
	const cursorLeft = useRef(false);
	const cursorRight = useRef(false);

	const spinnerTop = useRef(false);
	const spinnerLeft = useRef(false);
	const spinnerRight = useRef(false);


	useEffect(() => {
		anime({
			targets: spinnerTop.current,
			autoplay: play,
			loop: true,
			rotate: {
				value: 360,
				duration: 3000,
				easing: 'linear'
			}
		});
		anime({
			targets: spinnerLeft.current,
			autoplay: play,
			loop: true,
			rotate: {
				value: 360,
				duration: 2500,
				easing: 'linear'
			}
		});
		anime({
			targets: spinnerRight.current,
			autoplay: play,
			loop: true,
			rotate: {
				value: 360,
				duration: 2700,
				easing: 'linear'
			}
		});

		const tlOne = anime.timeline({
			loop: true,
			autoplay: play,
			easing: 'easeInOutSine'
		});

		const tlTwo = anime.timeline({
			loop: true,
			autoplay: play,
			easing: 'easeInOutSine'
		});

		tlOne
		.add({
			targets: cursorTop.current,
			duration: 2000,
			keyframes: [
				{translateX: '-8%', translateY: '-64%', duration: 700, endDelay: 400},
				{translateX: '-24%', translateY: '-24%', duration: 700, endDelay: 600},
				{scale: .9, duration: 100},
				{scale: 1, duration: 100},
				{scale: .9, duration: 100},
				{scale: 1, duration: 100, endDelay: 500},
				{translateX: '20%', translateY: '40%', duration: 700, endDelay: 400},
				{translateX: '0%', translateY: '0%', duration: 600, endDelay: 200},
			],
		});

		anime({
			targets: cursorLeft.current,
			autoplay: play,
			loop: true,
			duration: 3000,
			easing: 'easeOutElastic(1, .8)',
			keyframes: [
				{translateX: '20%', translateY: '30%', endDelay: 800},
				{translateX: '0%', translateY: '0%'},
				{translateX: '100%', translateY: '-70%', endDelay: 600},
				{translateX: '-10%', translateY: '30%', endDelay: 1000},
				{translateX: '0%', translateY: '0%'},
				{scale: .9, duration: 100},
				{scale: 1, duration: 100, endDelay: 2000}
			],
		});

		tlTwo
		.add({
			targets: cursorRight.current,
			duration: 6000,
			endDelay: 1000,
			easing: 'easeInOutSine',
			keyframes: [
				{translateX: '-50%', translateY: '-100%', endDelay: 200},
				{translateX: '0%', translateY: '0%', endDelay: 300},
				{scale: .9, duration: 100},
				{scale: 1, duration: 100, endDelay: 200},
				{translateX: '-20%', translateY: '-40%', endDelay: 800},
				{translateX: '0%', translateY: '0%'},
				{translateX: '-100%', translateY: '-70%', endDelay: 600},
				{translateX: '-10%', translateY: '30%', endDelay: 300},
				{scale: .9, duration: 100},
				{scale: 1, duration: 100, endDelay: 200},
				{translateX: '-50%', translateY: '-100%', endDelay: 1000}
			]
		});
	}, [play])
	return (
		<>
			<SpinnerLeft src={spinnerSrc} ref={spinnerLeft} />
			<CursorLeft src={cursorSrc} ref={cursorLeft} />
			<SpinnerRight src={spinnerSrc} ref={spinnerRight} />
			<CursorRight src={cursorSrc} ref={cursorRight} />
			<SpinnerTop src={spinnerSrc} ref={spinnerTop} />
			<CursorTop src={cursorSrc} ref={cursorTop} />
		</>
	)
};

export default Neustarten;